import React from 'react';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  size?: FontSize;
  weight?: FontWeight;
  align?: TextAlign;
  lineHeight?: number;
  children: React.ReactNode;
}

const Typography = (props: Props) => {
  const { className = '', size = 'medium', weight = 'normal', align = 'left', lineHeight = 1, children } = props;

  return <div
    className={`${styles.typography} ${styles[size]} ${styles[weight]} ${styles[align]} ${className}`}
    style={{ lineHeight }}
  >
    {children}
  </div>;
};

export default Typography;